import gsap from "gsap";
import { Quaternion, Euler } from "three";

// Используем Map с el.name как ключ
if (!window.__doorAnimationMap) {
    window.__doorAnimationMap = new Map();
}
export const doorAnimationMap = window.__doorAnimationMap || parent.__doorAnimationMap;

// Конечные положения для дверей (закрыто = исходное, открыто = поворот)
// Правая дверь: + угол, Левая дверь: - угол (для открытия в разные стороны)
const DOOR_POSITIONS = {
    closed: new Euler(0, 0, 0, "YXZ"), // Закрыто - начальное положение
    right_open: new Euler(0, Math.PI * 0.66, 0, "YXZ"), // Правая открыто - +120 градусов
    left_open: new Euler(0, -Math.PI * 0.66, 0, "YXZ"), // Левая открыто - -120 градусов
};

export function initDoorAnimation(el, isOpen = true) {
    // Убедимся что объект видимый
    let root = el;
    while (root && root.parent) {
        if (!root.visible) {
            root.visible = true;
        }
        root = root.parent;
    }

    // Определяем левая или правая дверь по имени
    const isLeftDoor = el.name.includes("levaya");

    // Сохраняем начальное состояние (закрыто)
    const closedQuat = new Quaternion().setFromEuler(DOOR_POSITIONS.closed);
    const openEuler = isLeftDoor ? DOOR_POSITIONS.left_open : DOOR_POSITIONS.right_open;
    const openQuat = new Quaternion().setFromEuler(openEuler);

    const keyName = el.name;
    doorAnimationMap.set(keyName, {
        el,
        closedQuat,
        openQuat,
        isOpen,
        tween: null, // GSAP tween (если идет анимация)
    });
}

export const DOOR_ANIM_DURATION = 0.8; // Длительность анимации в секундах

export function toggleDoor(el, shouldBeOpen, duration = DOOR_ANIM_DURATION) {
    if (!el) {
        console.error("❌ toggleDoor: элемент не передан!");
        return;
    }

    let data = doorAnimationMap.get(el.name);

    if (!data) {
        initDoorAnimation(el);
        data = doorAnimationMap.get(el.name);
        if (!data) {
            console.error("❌ Не удалось инициализировать дверь!");
            return;
        }
    }

    if (shouldBeOpen === undefined) {
        shouldBeOpen = !data.isOpen;
    }

    if (duration === 0) {
        const endQuat = shouldBeOpen ? data.openQuat : data.closedQuat;

        el.quaternion.copy(endQuat);
        data.isOpen = shouldBeOpen;

        if (data.tween) {
            data.tween.kill();
            data.tween = null;
        }

        return;
    }

    if (data.isOpen === shouldBeOpen) {
        return;
    }

    if (data.tween) {
        data.tween.kill();
    }

    const startQuat = el.quaternion.clone();
    const endQuat = shouldBeOpen ? data.openQuat : data.closedQuat;

    const animObj = { t: 0 };

    data.tween = gsap.to(animObj, {
        t: 1,
        duration: duration,
        ease: "power2.inOut",
        onUpdate: () => {
            el.quaternion.slerpQuaternions(startQuat, endQuat, animObj.t);
        },
        onComplete: () => {
            el.quaternion.copy(endQuat);
            data.tween = null;
        },
    });

    data.isOpen = shouldBeOpen;
}

export function isDoorOpen(doorName) {
    return !!doorAnimationMap.get(doorName)?.isOpen;
}

export function updateTextDoorState(node) {
    if (!(node instanceof HTMLElement)) return;

    node.textContent = isDoorOpen(servObj.activeWardrobeDoors[0]?.name) ? "Закрыть дверцы" : "Открыть дверцы";
}

export function toggleDoorsHandler({ target, shouldBeOpen, durationAnimation }) {
    if (servObj.activeWardrobeDoors && servObj.activeWardrobeDoors.length > 0) {
        servObj.activeWardrobeDoors.forEach((door) => {
            toggleDoor(door, shouldBeOpen, durationAnimation);
        });

        const isOpened = isDoorOpen(servObj.activeWardrobeDoors[0].name);

        const bool = typeof shouldBeOpen === "undefined" ? isOpened : shouldBeOpen;

        updateTextDoorState(target);
        animateMorphTargets(servObj.redactorModeObject, bool, durationAnimation);
    } else {
        console.error("❌ Активные двери не найдены!");
    }
}

export function animateMorphTargets(el, shouldBeOpen, duration = DOOR_ANIM_DURATION) {
    if (!el) return;

    const from = shouldBeOpen ? 0 : 1;
    const to = shouldBeOpen ? 1 : 0;

    el.traverse((child) => {
        // 👉 проверяем что это mesh и есть morphTargets
        if (!child.isMesh || !child.morphTargetInfluences) return;

        // если несколько morph targets — анимируем все
        child.morphTargetInfluences.forEach((_, index) => {
            const obj = { value: child.morphTargetInfluences[index] ?? from };

            gsap.to(obj, {
                value: to,
                duration,
                ease: "power2.inOut",
                onUpdate: () => {
                    child.morphTargetInfluences[index] = obj.value;
                },
            });
        });
    });
}
